var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#icon-facebook-22eaa';
                    var viewUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#view-icon-facebook-22eaa';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };